<template>
  <div class="knowledge-base">
    <div class="knowledge-base-nav">
      <div :class="['home-page', !currentBase.id ? 'home-page-active' : '']" @click="goHomePage"><i class="iconfont icon-quanbu1" /> 主页</div>
      <el-collapse class="nav-collapse">
        <el-collapse-item name="1" v-if="topAdmin">
          <template #title>
            <div class="collapse-title" >
              <span>
                <i style="margin-right: 5px;" class="iconfont icon-guanliyuan" />
                我创建的知识库
              </span>
              <Plus @click.stop="openAddBase" style="width: 1em; height: 1em; margin-right: 10px" />
            </div>
          </template>
          <div 
            :class="['nav-collapse-item', currentBase.id === item.id ? 'nav-collapse-item-active' : '']"
            v-for="item in selfBaseList" 
            :title="item.name"
            @click="baseClick(item)" 
            :key="item.id">
            {{ item.name }}
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template #title>
            <div class="collapse-title">
              <span>
                <i style="margin-right: 5px;" class="iconfont icon-zhanghao" />
                我参与的知识库
              </span>
            </div>
          </template>
          <div 
            :class="['nav-collapse-item', currentBase.id === item.id ? 'nav-collapse-item-active' : '']"
            v-for="item in joinBaseList"
            @click="baseClick(item)"
            :title="item.name"
            :key="item.id">
            {{ item.name }}
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="knowledge-base-main">
      <!-- 知识库列表 -->
      <baseList
        v-if="!isShowBase"
        :baseList="baseList" 
        :total="baseTotal"
        :topAdmin="topAdmin"
        @handle="baseHandle"
        @baseClick="baseClick"
        @pageChange="pageChange"
        @baseSearch="baseSearch"
      />
      <!-- 知识库内容 -->
      <aiBase
        v-else
        :baseInfo="currentBase"
        :topAdmin="topAdmin"
      />
    </div>
    <baseHandleDia
      ref="baseHandleDiaRef"
      @confirm="baseHandleCallBack"
    /> 
    <!-- <div class="knowledge-base-no-per">暂无权限</div> -->
  </div>
</template>

<script>
import { formatDate } from "@/api/global.js"
import { 
  addknowledgebase,
  getknowledgebaselist,
  getknowledgeper,
  getselfknowledgebaselist,
  updateknowledgebase,
  deleteknowledgebase,
  setknowledgepermission
} from '@/port/admins/ai.js'
import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue'
export default {
  name: 'knowledgeBase',
  data () {
    return {
      tabModel: 'card',
      searchListwd: '',
      baseList: [],
      joinBaseList: [],
      selfBaseList: [],
      isShowBase: false,
      currentBase: {},
      topAdmin: false,
      pageNum: 1,
      baseTotal: 0,
      searchName: ''
    }  
  },
  computed: {},
  components: {
    baseHandleDia: defineAsyncComponent(() => import('./baseList/baseHandleDia.vue')),
    baseList: defineAsyncComponent(() => import('./baseList')),
    aiBase: defineAsyncComponent(() => import('./aiBase')),
  },
  watch: {
  },
  methods: {
    // 回到主页
    goHomePage () {
      this.isShowBase = false
      if (this.currentBase) {
        this.currentBase = {}
      }
    },
    // 知识库页数切换
    pageChange (val) {
      this.pageNum = val
      this.getAiBase()
    },
    // 知识库搜索
    baseSearch (name) {
      this.searchName = name
      this.pageNum = 1
      this.getAiBase(name)
    },
    // 知识库点击
    baseClick (item) {
      this.currentBase = cloneDeep(item)
      this.isShowBase = true
    },
    // 知识库操作
    baseHandle (key, item) {
      if (key === 'del') {
        this.deleteAiBase(item)
      } else {
        this.$refs.baseHandleDiaRef.open({ type: key, data: item })
      }
    },
    // 知识库操作返回
    baseHandleCallBack ({ data, type, originalData }) {
      if (type === 'add') {
        this.addAiBase(data)
      } else if (type === 'set') {
        this.updateAiBase(data, originalData)
      } else if (type === 'permission') {
        this.updateAiBasePer(data)
      }
    },
    // 新增知识库
    async addAiBase (data) {
      const { code, msg } = await addknowledgebase(data)
      if (code === 0) {
        this.$message.success('新增成功')
        this.getAiBase()
        this.getSelfBase()
      } else {
        this.$message.error(msg)
      }
    },
    // 修改知识库
    async updateAiBase (data, originalData) {
      const query = {
        id: data.id
      }
      // 有修改再去请求接口
      let isUpdate = false
      // 修改了什么就传什么
      const keyList = ['description', 'name', 'model', 'pic']
      for (const key of keyList) {
        if (data[key] !== undefined && data[key] !== originalData[key]) {
          query[key] = data[key]
          isUpdate = true
        }
      }
      if (!isUpdate) return
      const { code, msg } = await updateknowledgebase(query)
      if (code === 0) {
        this.$message.success('修改成功')
        this.getAiBase()
        // 如果修改的是自己创建的知识库也要重新获取
        if (this.getIsBase(query, 'selfBaseList')) {
          this.getSelfBase()
        }
        if (this.getIsBase(query, 'joinBaseList')) {
          this.getJoinAiBase()
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 设置知识库权限
    async updateAiBasePer (val) {
      let query = {
        id: val.id,
        data: val.per
      }
      const { code, msg } = await setknowledgepermission(query)
      if (code === 0) {
        this.$message.success('设置成功')
      } else {
        this.$message.warning(msg)
      }
    },
    // 删除知识库
    deleteAiBase (data) {
      const h = `
        <Warning style="color: #e6a23c; width: 1em; height: 1em;" />
        <strong>删除知识库</strong>
        <div style="font-size: 12px;color: #A4A4A6">知识库删除后，所有内容将被删除，所有成员将不能再访问。请谨慎操作！</div>
        <div style="font-size: 12px;color: #A4A4A6">请输入“确认删除”以确认</div>
      `
      this.$prompt(h, '提示', {
        inputPattern: /^确认删除$/,
        inputErrorMessage: '输入内容必须为“确认删除”',
        confirmButtonText: '确定',
        cancelButtonText: '取消删除',
        inputPlaceholder: '确认删除',
        dangerouslyUseHTMLString: true,
      }).then(async () => {
        const query = { id: data.id }
        const { code, msg } = await deleteknowledgebase(query)
        if (code === 0) {
          this.$message.success('删除成功')
          const index = this.baseList.findIndex(item => { return item.id === data.id })
          if (index !== -1) {
            this.baseList.splice(index, 1)
            // 修改一下左侧的知识库列表
            if (this.getIsBase(query, 'selfBaseList')) {
              this.getSelfBase()
            }
            if (this.getIsBase(query, 'joinBaseList')) {
              this.getJoinAiBase()
            }
          }
        } else {
          this.$message.error(msg)
        }
      }).catch(() => { })
    },
    // 判断操作的知识库存不存在这个知识库列表
    getIsBase (item, key) {
      let flag = false
      if (item.id) {
        const index = this[key].find(item => { return item.id === item.id })
        if (index !== -1) {
          flag = true
        }
      }
      return flag
    },
    // 获取全部知识库列表
    async getAiBase () {
      const query = { curpage: this.pageNum, pagesize: 10, all: 1 }
      if (this.searchName) {
        query.name = this.searchName
      }
      const { code, data, msg, total } = await getknowledgebaselist(query)
      if (code === 0) {
        this.baseTotal = total
        this.baseList = data.map(item => {
            const obj = cloneDeep(item)
            if (item.ctime) {
              obj.time = formatDate(item.ctime, 'yyyy-MM-dd hh:mm')
            }
            return obj
          })
      } else {
        this.$message.error(msg)
      }
    },
    // 判断有没有权限创建个人知识库
    async getSelfBasePer () {
      const { code, data } = await getknowledgeper() 
      if (code === 0 && data) {
        this.topAdmin = data.selfknowledge
        this.getSelfBase()
      }
    },
    // 获取我创建的知识库列表
    async getSelfBase () {    
      if (!this.topAdmin) return 
      const { code, data, msg } = await getselfknowledgebaselist({ curpage: 0, pagesize: 0 })
      if (code === 0) {
        this.selfBaseList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 获取我参与的知识库列表
    async getJoinAiBase () {
      const { code, data, msg } = await getknowledgebaselist({ curpage: 0, pagesize: 0 })
      if (code === 0) {
        this.joinBaseList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 文件夹点击
    folderClick (item) {
      this.$router.push({
        path: 'folder', 
        query: { id: item.id }
      })
    },
    // 新增知识库
    openAddBase () {
      const data = {
        name: '',
        description: '',
        model: 7,
        pic: 'https://bigdata.topeti.com/PCRepository/mainPlatform/baseDefaultCover.png'
      }
      this.$refs.baseHandleDiaRef.open({ type: 'add', data })
    },
    // 搜索分组
    searchList () {
      if (this.searchListwd === undefined || this.searchListwd == '') return 
      // this.getBaseGroup (this.searchListwd)
    },
    getBaseGroup () {}
  },
  mounted () {
    this.getSelfBasePer()
    this.getAiBase()
    this.getJoinAiBase()
  },
}
</script>

<style lang="scss" scoped>
.knowledge-base {
  width: 100%;
  height: 100%;
  display: flex;
  .knowledge-base-no-per {
    width: 100%;
    height: 100%;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-nav {
    width: 200px;
    padding: 20px 10px;
    height: 100%;
    background-color: #F5F7FB;
    box-sizing: border-box;
    .home-page {
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      border-radius: 5px;
      padding: 0 10px;
      i {
        margin-right: 5px;
      }
      &:hover {
        background-color: #E3ECFC;
        color: #3B83FB;
      }
    }
    .home-page-active {
      background-color: #E3ECFC;
      color: #3B83FB;
    }
    .nav-collapse {
      position: relative;
      height: calc(100% - 70px);
      overflow: auto;
      .collapse-title {
        width: 100%;
        color: #404041;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &-item {
        padding-left: 30px;
        height: 46px;
        line-height: 46px;
        border-radius: 5px;
        cursor: pointer;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden;    /* 隐藏溢出的文本 */
        text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
        &:hover {
          background-color: #E3ECFC;
          color: #3B83FB;
        }
      }
      &-item-active {
        background-color: #E3ECFC;
        color: #3B83FB;
      }
    }
    :deep(.el-collapse)  {
      border: none;
      .el-collapse-item__header {
        background-color: transparent;
        border: none;
        padding-right: 0;
        .el-collapse-item__arrow {
          display: none;
        }
      }
      .el-collapse-item__wrap {
        background-color: transparent;
      }
    }
  }
  &-main {
    flex: 1;
    height: 100%;
    background-color: #FFFFFF;
    box-sizing: border-box;
  }
}
</style>